<template>
  <sp-modal :title="title" ref="modal" size="xl">
    <b-row no-gutters>
      <!-- -->
      <b-col cols="2">
        <sp-form-input label="Matrícula" v-model="alocacao.matricula" disabled class="pr-2" />
      </b-col>
      <b-col cols="2">
        <sp-form-input label="CPF" v-model="pessoa.cpf" disabled class="pr-2" />
      </b-col>
      <b-col cols="2">
        <sp-form-input label="PIS/PASEP" v-model="pessoa.pisPasep" disabled class="pr-2" />
      </b-col>
      <b-col cols="2">
        <sp-form-input label="Identidade" v-model="pessoa.identidade" disabled class="pr-2" />
      </b-col>
      <b-col cols="2">
        <sp-form-input
          label="No Dependentes IR"
          v-model="alocacao.numeroDependentesIr"
          disabled
          class="pr-2"
        />
      </b-col>
      <b-col cols="2">
        <sp-form-input
          label="No Dep. Sal. Família"
          v-model="alocacao.numeroDependentesSalarioFamilia"
          disabled
        />
      </b-col>
      <!-- -->
      <b-col cols="12">
        <sp-form-input label="Nome" v-model="pessoa.nome" disabled />
      </b-col>
      <!-- -->
      <b-col cols="4">
        <sp-form-input label="Vínculo" v-model="alocacao.filial" disabled class="pr-2" />
      </b-col>
      <b-col cols="4">
        <sp-form-input label="Cargo" v-model="alocacao.cargo" disabled class="pr-2" />
      </b-col>
      <b-col cols="4">
        <sp-form-input label="Admissão" v-model="admissao" disabled />
      </b-col>
      <!-- -->
      <b-col cols="6">
        <sp-form-input label="Lotação" v-model="alocacao.centroDeCusto" disabled class="pr-2" />
      </b-col>
      <b-col cols="6">
        <sp-form-input label="Cargo comissionado" v-model="alocacao.cargoComissionado" disabled />
      </b-col>
      <!-- -->
      <b-col cols="5">
        <sp-form-input label="Dados bancários" v-model="bancario" disabled class="pr-2" />
      </b-col>
      <b-col>
        <sp-form-input label="Tipo de folha" v-model="paycheck.tipo" disabled class="pr-2" />
      </b-col>
      <b-col>
        <sp-form-input label="Referência" v-model="referencia" disabled class="pr-2" />
      </b-col>
      <b-col>
        <sp-form-input label="Aposentadoria" v-model="alocacao.aposentaria" disabled />
      </b-col>
      <!-- -->
      <b-col cols="12">
        <sp-grid unique="nome" :fields="fields" :items="rubricas" />
      </b-col>
      <!-- -->
      <b-col cols="4">
        <sp-form-money label="Total de ganhos" v-model="paycheck.ganhos" disabled class="pr-2" />
      </b-col>
      <b-col cols="4">
        <sp-form-money
          label="Total de descontos"
          v-model="paycheck.descontos"
          disabled
          class="pr-2 mb-3"
        />
      </b-col>
      <b-col cols="4">
        <sp-form-money label="Total liquido" v-model="paycheck.liquido" disabled />
      </b-col>
      <!-- -->
      <b-col>
        <sp-form-input label="Base Cálculo FGTS" v-model="baseCalculoFgts" disabled class="pr-2" />
      </b-col>
      <b-col>
        <sp-form-input label="Valor FGTS" v-model="valorFgts" disabled class="pr-2" />
      </b-col>
      <b-col>
        <sp-form-input
          label="Base de Cálculo Previdência"
          v-model="baseCalculoPrevidencia"
          disabled
          class="pr-2"
        />
      </b-col>
      <b-col>
        <sp-form-input
          label="Base de Cálculo IRRF"
          v-model="baseCalculoIrrf"
          disabled
          class="pr-2"
        />
      </b-col>
      <b-col>
        <sp-form-input label="Margem Consignável" v-model="margemConsignavel" disabled />
      </b-col>
      <!-- -->
      <b-col cols="12">
        <div class="text-right mt-2">
          <sp-button class="mr-3" variant="warning" @click="hide">
            <i class="fas fa-times"></i> Cancelar
          </sp-button>
          <sp-button variant="primary" @click="print">
            <i class="fas fa-print"></i> Imprimir
          </sp-button>
        </div>
      </b-col>
    </b-row>
  </sp-modal>
</template>
<script>
import { paycheckService } from '@/services';
import dates from '@/utils/dates';

export default {
  data() {
    return {
      paycheck: this.getBlank(),
      fields: [
        { key: 'descricao', label: 'Descrição' },
        { key: 'vantagem', label: 'Vantagens' },
        { key: 'desconto', label: 'Descontos' },
      ],
    };
  },
  methods: {
    getBlank() {
      return {
        alocacao: {
          pessoa: {},
        },
        rubricas: [],
      };
    },
    show(paycheck) {
      this.paycheck = this.getBlank();
      this.$refs.modal.show();
      this.get(paycheck.id);
    },
    hide() {
      this.$refs.modal.hide();
    },
    async print() {
      try {
        const file = await paycheckService.print(this.paycheck.id);

        const link = document.createElement('a');
        document.body.appendChild(link);
        link.href = window.URL.createObjectURL(new Blob([file]));
        link.download = 'contracheque.pdf';
        link.target = '_blank';
        link.click();
      } catch (e) {
        console.log(e);
        this.$alertify.error('Erro ao gerar o PDF do contracheque');
      }
    },
    async get(id) {
      this.paycheck = await paycheckService.get(id);
    },
    parseMoney(str) {
      const sanitized = str.replace('.', '').replace(',', '.');
      return Number(sanitized).toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
      });
    },
  },
  computed: {
    title() {
      const { mes, ano, tipo } = this.paycheck;
      return `Contracheque de ${mes}/${ano} - Folha: ${tipo}`;
    },
    referencia() {
      const { mes, ano } = this.paycheck;
      return `${mes}/${ano}`;
    },
    alocacao() {
      return this.paycheck.alocacao;
    },
    pessoa() {
      return this.paycheck.alocacao.pessoa;
    },
    admissao() {
      return dates.fromISO(this.alocacao.admissao);
    },
    baseCalculoFgts() {
      return this.alocacao.baseCalculoFgts
        ? this.parseMoney(this.alocacao.baseCalculoFgts)
        : 'R$ 0,00';
    },
    valorFgts() {
      return this.alocacao.valorFgts ? this.parseMoney(this.alocacao.valorFgts) : 'R$ 0,00';
    },
    baseCalculoPrevidencia() {
      return this.paycheck.baseCalculoPrevidencia
        ? this.parseMoney(this.paycheck.baseCalculoPrevidencia)
        : 'R$ 0,00';
    },
    baseCalculoIrrf() {
      return this.paycheck.baseCalculoIrrf
        ? this.parseMoney(this.paycheck.baseCalculoIrrf)
        : 'R$ 0,00';
    },
    margemConsignavel() {
      return this.paycheck.margemConsignavel
        ? this.parseMoney(this.paycheck.margemConsignavel)
        : 'R$ 0,00';
    },
    bancario() {
      const { banco, agencia, conta } = this.paycheck;
      const validatedBanco = banco ? `Banco: ${banco}` : '';
      const validatedAgencia = agencia ? `| Agência: ${agencia}` : '';
      const validatedConta = conta ? `| Conta: ${conta}` : '';
      return `${validatedBanco} ${validatedAgencia} ${validatedConta}`;
    },
    rubricas() {
      return this.paycheck.rubricas.map((rubrica) => {
        const parsedRubrica = this.parseMoney(rubrica.valor);
        const vantagem = rubrica.tipo === 'CREDITO' ? parsedRubrica : 'R$ 0,00';
        const desconto = rubrica.tipo === 'DEBITO' ? parsedRubrica : 'R$ 0,00';
        return {
          descricao: rubrica.nome,
          vantagem,
          desconto,
        };
      });
    },
  },
};
</script>
